import React, {
  createRef,
  useEffect,
  useState,
  CSSProperties,
  useRef,
} from "react";
import CloseIcon from "../../../images/close.svg";
import DefaultImage from "../../../images/image.svg";
import { IMAGE_BASE_URL } from "../../../helpers/constants";
import SearchInput from "../../../components/SearchInput";
import axios from "../../../helpers/axios";
import { useSelector } from "react-redux";
import { Button, Tooltip } from "@mui/material";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

export default function AgentVisibilityPopup({
  intialAgentValues,
  onFinish,
  onHide,
  initialRule,
}) {
  const agentVisibilityRules = useSelector(
    (state) => state.settings.agentVisibilityRules
  );
  const [agentRule, setAgentRule] = useState(initialRule);
  const [isAllAgentSelected, setAllAgentSelected] = useState(0);
  const [allAgents, setAllAgents] = useState([]);
  const [preselectedAgents, setpreselectedAgents] = useState(intialAgentValues);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(true);
  const [disableList, setDisableList] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    // Select all checkboxes All Agents rule selected
    if (isAllAgentSelected == 1) {
      setAllAgents(
        allAgents.map((a, i) => {
          a.checked = true;
          return a;
        })
      );
      setDisableList(true);
    } else {
      setDisableList(false);
    }
  }, [agentRule]);

  useEffect(() => {
    setpreselectedAgents(intialAgentValues);
  }, [intialAgentValues]);

  const onChangeHandler = (e) => {
    const index = e.target.selectedIndex;

    setAllAgentSelected(agentVisibilityRules[index - 1].allAgents);
    setAgentRule(agentVisibilityRules[index - 1].id);
    if (index !== 3) {
      setAllAgents(
        allAgents.map((a, i) => {
          a.checked = false;
          return a;
        })
      );
    }
  };

  useEffect(() => {
    // fetch agent API
    (async () => {
      try {
        const response = await axios.post(
          `/admin/agent/list/all`,
          { keyword: searchText }
        );
        const data = response.data?.data;
        //console.log("agent data::", data);
        if (!Array.isArray(data)) return;

        setAllAgents(
          data?.map((a, i) => {
            if (preselectedAgents?.includes(a?.id)) {
              return { ...a, checked: true };
            }
            return a;
          })
        );
      } catch (e) {
        console.error(e);
        // report
      } finally {
        setLoading(false);
      }
    })();
  }, [searchText]);

  const onSubmit = () => {
    setSubmitted(true);
    if (!agentRule) return;
    let selectedRuleInfo = agentVisibilityRules.find(
      (r) => agentRule && r.id == agentRule
    );
    const checkedAgents = [];
    let agentList = [...allAgents].filter((item) => {
      if (item?.checked == true) {
        checkedAgents.push(item);
      }

      if (selectedRuleInfo?.allAgents == 1) return true;
      else if (selectedRuleInfo?.excludeAgents == 1) {
        return !item.checked;
      }

      return item.checked;
    });
    onFinish && onFinish({ agentRule, agentList, checkedAgents });
  };

  const handleCheckboxChange = (e) => {
    const updatedItems = allAgents.map((item) => {
      if (item.id === e.target.id) {
        return { ...item, checked: !item.checked };
      }
      return item;
    });
    setAllAgents(updatedItems);
  };

  return !loading ? (
    <div className="bg-black bg-opacity-70 fixed z-[999] w-[100%] h-full left-0 top-0 flex justify-center items-center">
      <form className="w-full max-w-5xl bg-white top-0 h-auto right-[320px] py-2 rounded-md">
        <div className="flex px-6 py-4 justify-between items-center">
          <h3 className="text-md font-bold tracking-[-.15px]">
            Select Visibility Agents
          </h3>
          <div
            className="bg-gray-100 px-2 py-2 rounded-md hover:bg-gray-200 transition-all cursor-pointer"
            onClick={onHide}
          >
            <img src={CloseIcon} className="w-5 h-5" />
          </div>
        </div>
        <div className="flex flex-col px-6 py-4 pt-4 w-full ">
          <div className="flex grid-col-12 justify-between items-center">
            <div className="col-span-3 flex-[0_0_auto] mr-2">
              <select
                onChange={onChangeHandler}
                value={agentRule}
                required={true}
                className={`text-xs py-3 px-3 md:py-3 md:px-4 rounded-[8px] ${
                  !agentRule && submitted
                    ? "error-shadow border"
                    : "border-[#d9d9d9]"
                }`}
              >
                <option value={""}>Select Rule</option>
                {agentVisibilityRules.map((item, index) => {
                  return (
                    <option
                      value={item.id}
                      checked={item.id == agentRule}
                      key={index}
                    >
                      {item.name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col-span-7 flex-1">
              <Input
                size="large"
                style={{ height: "41.5px", fontSize: "13px" }}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                prefix={<SearchOutlined />}
                placeholder="Search Agent"
              />
            </div>
          </div>
        </div>

        <div className="mt-5 px-8 py-4 pt-2 w-full  h-[250px] overflow-y-scroll">
          <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-5 gap-x-3 gap-y-1 sm:gap-x-4 sm:gap-y-2">
            {allAgents?.map((item, index) => {
              return (
                <AgentItem
                  all={disableList}
                  {...item}
                  key={index}
                  onChange={handleCheckboxChange}
                />
              );
            })}
          </div>
        </div>
        <div className="flex mt-4 px-8 py-4 pt-4 justify-end">
          <Button onClick={onHide} className={"can_btn"} size="small">
            Cancel
          </Button>
          <div className="mr-2 " />
          {agentRule ? (
            <Button
              className="sav_btn"
              size="small"
              onClick={onSubmit}
              disabled={
                allAgents?.filter((it) => it.checked === true)?.length < 1
              }
            >
              Done
            </Button>
          ) : (
            <Tooltip title={"Select agent rule"} arrow>
              <Button
                className="sav_btn"
                size="small"
                onClick={onSubmit}
                disabled={
                  allAgents?.filter((it) => it.checked === true)?.length < 1
                }
              >
                Done
              </Button>
            </Tooltip>
          )}
        </div>
      </form>
    </div>
  ) : null;
}

const AgentItem = ({ id, icon, name, checked, all = false, onChange }) => {
  return (
    <label htmlFor={id} className={`${all ? "opacity-50" : ""}`}>
      <div className="flex px-1 py-1 sm:px-2 sm:py-2 items-center bg-[#f5f7f9] rounded md:rounded-md">
        <input
          id={id}
          checked={checked}
          type={"checkbox"}
          className={`w-2 h-2 sm:w-3 sm:h-3 mr-1 sm:mr-2  mb-0 border-gray-100`}
          required={false}
          onChange={all ? (e) => {} : onChange}
        />
        <div className="w-3 h-3 sm:w-4 sm:h-4 rounded-lg mr-1 overflow-hidden flex-shrink-0">
          <img src={icon ? `${IMAGE_BASE_URL}/${icon}` : DefaultImage} />
        </div>
        <div className="flex-1 overflow-hidden ">
          <p className="text-[9px] sm:text-[13px] font-semibold text-black capitalize truncate">
            {name}
          </p>
        </div>
      </div>
    </label>
  );
};
